// extracted by mini-css-extract-plugin
export default {"unit":"8px","colorShuttleGrey":"#5C6770","colorViolet":"#080837","conditions":"MOcx2SPu3e_1ddiKziTC","subtitle":"Sw5I1P4U1DbwCCKpcsS_"};